// Cart reservation countdown. Shared end-time in module scope so the timer
// survives the cart drawer's innerHTML re-renders and stays in sync across
// every [data-cart-timer] element. Resets to full duration on a page load.
(function () {
  var endTime = null;

  function format(totalSeconds) {
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function tick() {
    var els = document.querySelectorAll('[data-cart-timer]');
    if (!els.length) return;

    if (endTime === null) {
      var mins = parseInt(els[0].getAttribute('data-minutes'), 10) || 10;
      endTime = Date.now() + mins * 60 * 1000;
    }

    var remaining = Math.max(0, Math.round((endTime - Date.now()) / 1000));
    var text = format(remaining);
    els.forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  setInterval(tick, 1000);
  tick();
})();
